import type { Goal } from "@features/api/TrackerApi";
import { PLAN_DIAGNOSIS_SOURCE } from "@hooks/plan/planDiagnosisSource";

interface OnboardingDiagnosisFields {
  source?: unknown;
  goalType?: unknown;
}

const parseOnboardingGoalType = (
  raw: string | undefined,
): string | undefined => {
  if (!raw?.trim()) {
    return undefined;
  }
  try {
    const parsed = JSON.parse(raw) as OnboardingDiagnosisFields | null;
    if (parsed?.source !== PLAN_DIAGNOSIS_SOURCE.ONBOARDING_V3_0_1) {
      return undefined;
    }
    return typeof parsed.goalType === "string" && parsed.goalType.trim()
      ? parsed.goalType.trim()
      : undefined;
  } catch {
    return undefined;
  }
};

/**
 * onboarding 所选 goalType（EDG-591 要数据槽取题用）。
 * onboarding 草稿 goal 的 `diagnosis_content` 带 `{source:"onboarding_v3_0_1", goalType}`
 * （perplexica plan-preview-orchestrator `createInactiveDraft`）；重做 onboarding 会有多条，取最新。
 */
export function deriveOnboardingGoalType(
  goals: readonly Goal[] | undefined,
): string | undefined {
  let latest: { goalType: string; created: number } | undefined;
  for (const goal of goals ?? []) {
    const goalType = parseOnboardingGoalType(goal.diagnosis_content);
    if (!goalType) {
      continue;
    }
    const created = goal.created ?? 0;
    if (!latest || created > latest.created) {
      latest = { goalType, created };
    }
  }
  return latest?.goalType;
}
